import { UserServiceService } from '../user-service.service';
import { Component, OnInit ,Inject} from '@angular/core';
import {CEpapers , DSEpapers, topics , sqtype} from '../static'
import { QuestionService } from './../question.service';
import {MatDialog , MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css']
})
export class SideBarComponent implements OnInit {
  CEpapers = CEpapers;
  DSEpapers = DSEpapers;
  year;
  current_type;
  current_paper;
  current_topic;
  current_exam;
  byyear = true;
  theme;
  topics = topics;  
  sqtype = sqtype;
  constructor(
    private QuestionService: QuestionService,
    public dialog: MatDialog,
    public user: UserServiceService,
  ) { }
    
  ngOnInit() {
    Object.assign(this, {
      current_type : 'topic',
      current_exam : 'DSE',
      current_paper : 'mc',
    })
   
    this.getColor();

  }
  
  setPaper(paper){  this.current_paper = paper;      }
  setYear(year){  this.year = year;      }
  setType(type){  this.current_type = type;          }
  setTopic(topic){ this.current_topic = topic;   }
  setExam(exam){this.current_exam = exam;      }
  
  getColor(){
    console.log("Getting Color")
    var xhr = new XMLHttpRequest();        
    xhr.open('POST', 'https://api.studydse.net/api/get_color.php');
    xhr.withCredentials = true;
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.onload = () => {
          var color = JSON.parse(xhr.responseText);
          console.log(color[0].color);
          this.setColor(color[0].color);
    };
    xhr.send();
  }
  setColor(color){
    console.log("Setting Color")
    this.theme = (document.getElementById("theme") as HTMLFormElement);

    let colors = {
      R: 'red',
      O: 'orange',
      G: 'green',
      P: 'purple',
      B: 'blue',
      Y: 'yellow',
      DO: 'deep-orange',
      PINK: 'pink',
      BL: 'black',
      DG: 'dark-grey',
      LB: 'light-blue',
      CY: 'cyan',
      DP: 'deep-purple',
      IND: 'indigo',
    }
    this.theme.href = 'https://www.w3schools.com/lib/w3-theme-'+colors[color]+'.css';    
    
  }
  updateColor(color){
    console.log("Updating Color", color)
    var xhr = new XMLHttpRequest();        
    xhr.open('POST', 'https://api.studydse.net/api/set_color.php');
    xhr.withCredentials = true;
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.onload = () => {
          console.log( xhr.responseText);
          
    };
    xhr.send('color=' + color);
    
  }
  mySidebar;
  overlayBg;

  w3_open() {
    this.mySidebar = (document.getElementById("mySidebar") as HTMLFormElement);
    this.overlayBg = (document.getElementById("myOverlay")as HTMLFormElement);
    
    if (this.mySidebar.style.display === 'block') {
      this.mySidebar.style.display = 'none';
      this.overlayBg.style.display = "none";
    } else {
      this.mySidebar.style.display = 'block';
      this.overlayBg.style.display = "block";
    }
  }
  
  // Close the sidebar with the close button
  w3_close() {
    this.mySidebar = (document.getElementById("mySidebar") as HTMLFormElement);
    this.overlayBg = (document.getElementById("myOverlay")as HTMLFormElement);
    this.mySidebar.style.display = "none";
    this.overlayBg.style.display = "none";
  }

  openColor() {
    const dialogRef = this.dialog.open(DialogContentExampleDialog2, {
      width: '500px',
      
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.setColor(result);
      this.updateColor(result);
    });
     
   }

   openQuestionCreator() {
    this.dialog.open(QuestionCreator,{
      data: { topics: topics },
    });
     
   }

   
 }
 
 @Component({
   selector: 'dialog-content-example-dialog2',
   templateUrl: './dialog-content-example-dialog.html',
 })
 export class DialogContentExampleDialog2 {}

 @Component({
  selector: 'question-creator',
  templateUrl: './question-creator.html',
})

export class QuestionCreator {
  constructor(@Inject(MAT_DIALOG_DATA) public data) {}

  
}